import React from 'react';

export const Mainpage = React.lazy(() => import('../components/MainPage'));
export const HomePage = React.lazy(() => import('../components/HomePage'));
export const ContactPage = React.lazy(() => import('../components/Contactus'));
export const PrivacyPolicy = React.lazy(() => import("../components/PrivacyPolicy") ) ;
export const GrievAndRedressal = React.lazy(() => import("../components/GrievRedressal"));
export const TAndC = React.lazy(() => import("../components/TandC"));
export const Support = React.lazy(() => import("../components/Support"))
export const CancelAndRefund = React.lazy(() => import("../components/CancelAndRefund"))